import axios from "axios";

export const submitEmailSubscriptions = (request: any) => {
  return axios({
    method: "post",
    url: "https://script.google.com/macros/s/AKfycbxdo569bZMkTsQHuE3qFzO2dEwpoyOly6MbAlVUU2YlM-kMYUxcUMGYxL1_cksL1UsiPQ/exec",
    headers: { "Content-Type": "multipart/form-data" },
    data: request,
  });
};
